'use client';

import useCart from '@/store/cart.store';
import CartPopUpWrapper from './cart-popup-wrapper';
import { useEffect, useState } from 'react';
import { calcCartTotalHandler } from '@/helpers/cart';

const CartPopup = () => {
  const state = useCart((store) => store);
  const [isReloaded, setIsReloaded] = useState(false);
  const total = calcCartTotalHandler(state?.cartItems || []);

  // Start Of Close Popup after Reload Page
  useEffect(() => {
    if (window?.performance?.navigation?.type === 1) {
      setIsReloaded(true);
    }
  }, []);

  useEffect(() => {
    if (isReloaded && state.cartpopup) {
      state.togglePopup();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReloaded]);

  // End Of Close Popup after Reload Page

  useEffect(() => {
    if (state?.cartItems?.length === 0 && state.cartpopup) {
      state.togglePopup();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.cartItems]);
  return state?.cartpopup ? (
    <CartPopUpWrapper
      togglePopup={state?.togglePopup}
      cartItems={state?.cartItems}
      total={total}
    />
  ) : null;
};

export default CartPopup;
